// @flow

import {combineReducers} from "redux"
import products from "./products"
import user from "./user"
import baby from "./baby"
import tasks from "./tasks"
import planning from "./planning"
import searchItems from "./search-items"
import babies from "./babies"
import shop from "./shop"
import babyListInvoice from "./baby-list-invoice"
import invoice from "./invoice"
import type {State} from "../types"

const rootReducer: State = combineReducers({
  user,
  products,
  baby,
  tasks,
  planning,
  searchItems,
  babies,
  shop,
  babyListInvoice,
  invoice,
})

export default rootReducer
